import {isNil} from 'ramda';

import {PdfExportError} from 'features/pdf-export';

import type {EagGridState} from '../store/createEagGridStore';
import {selectPdfExportUnavailableReason} from '../store/selectors/selectPdfExportUnavailableReason';
import type {GridPdfExportRequest} from '../types/GridPdfExportRequest';

/** Capture IDs and the loaded request at click time, without retaining displayed cell values. */
export function captureGridPdfExport(
  state: EagGridState,
  requiredColumns: readonly string[]
): GridPdfExportRequest {
  const reason = selectPdfExportUnavailableReason(state);
  if (!isNil(reason) || isNil(state.definition) || isNil(state.loadedPageRequest)) {
    throw new PdfExportError(
      'module.reportDocument.labels.dataUnavailable',
      false,
      'entity.integration.labels.pleaseRefresh'
    );
  }
  const columns = state.definition.columns
    .filter((column) => requiredColumns.includes(column.key))
    .map(({key, title}) => ({key, title}));
  const availableKeys = new Set(columns.map((column) => column.key));
  const rows = state.rows.filter((row) => state.selectedRowIds.has(row.id));
  if (
    requiredColumns.some((key) => !availableKeys.has(key)) ||
    rows.length !== state.selectedRowIds.size
  ) {
    throw new PdfExportError('module.reportDocument.labels.dataUnavailable');
  }
  return structuredClone({
    gridCode: state.gridCode,
    ...state.loadedPageRequest,
    recordIds: rows.map((row) => row.id),
    requiredColumns: [...new Set(requiredColumns)],
    columns,
    exportedAt: new Date(),
  });
}
